import { translate } from "app/filters/i18nFilter";
import { createPluralHelperForI18nKey } from "app/pages/sales-intelligence/utils/strings";
import type { SignalTimeframe } from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalTimeframe";
import { DAYS_IN_MONTH, DAYS_IN_WEEK, DAYS_IN_YEAR } from "app/services/date-time/constants";
import { SI_TIMEFRAME_PREFIX, TODAY, DAY, MONTH, WEEK, YEAR, AGO } from "../../../constants/translationKeys";

const getTimeFrameTranslation = (timeframe: Readonly<SignalTimeframe>): string => {
    const { amount, id } = timeframe;
    const getI18nSingularKey = createPluralHelperForI18nKey(`${SI_TIMEFRAME_PREFIX}.${id}`);

    if (amount === 1) {return `1 ${translate(getI18nSingularKey(1))?.toLowerCase()}`;}

    return translate(`${SI_TIMEFRAME_PREFIX}.${id}`, { amount });
};

export const getSignalEventPeriod = (amount: number): string => {
    if (amount < DAYS_IN_WEEK) {
        return `${getTimeFrameTranslation({ amount, id: DAY })}`;
    }
    if (amount >= DAYS_IN_WEEK && amount < DAYS_IN_MONTH) {
        return `${getTimeFrameTranslation({
            amount: Math.floor(amount / DAYS_IN_WEEK),
            id: WEEK,
        })}`;
    }
    if (amount >= DAYS_IN_MONTH && amount < DAYS_IN_YEAR) {
        return `${getTimeFrameTranslation({
            amount: Math.floor(amount / DAYS_IN_MONTH),
            id: MONTH,
        })}`;
    }
    return `${getTimeFrameTranslation({
        amount: Math.floor(amount / DAYS_IN_YEAR),
        id: YEAR,
    })}`;
};

export const getSignalEventDate = (amount: number): string => {
    if (amount === 0) {
        return translate(TODAY);
    }
    return `${getSignalEventPeriod(amount)} ${translate(`${SI_TIMEFRAME_PREFIX}.${AGO}`)}`;
};
